import { UI } from './ui.model';

export class SwipeUI extends UI {
  dataUI: {
    didSwipe: boolean
  }
}